import { render, staticRenderFns } from "./ScreeningProgressBreakdown.vue?vue&type=template&id=a35411ce&"
import script from "./ScreeningProgressBreakdown.vue?vue&type=script&lang=js&"
export * from "./ScreeningProgressBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports